import { render } from "./bulk-suppliers-upload.vue?vue&type=template&id=3d88476a"
import script from "./bulk-suppliers-upload.vue?vue&type=script&lang=js"
export * from "./bulk-suppliers-upload.vue?vue&type=script&lang=js"

import "./bulk-suppliers-upload.vue?vue&type=style&index=0&id=3d88476a&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\personal\\ims-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__